import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        //lOCAL
        // clientId: "dc33c71d-b7dc-46c9-a3f7-3d384de95002",
        // authority: "https://login.microsoftonline.com/common",
        // redirectUri: "http://localhost:3000/",


        //UAT DEV PROD
        clientId: "0d5af298-f1a2-4e4f-8561-1599cfd73152",
        authority: "https://login.microsoftonline.com/0cdcb198-8169-4b70-ba9f-da7e3ba700c2",
        // redirectUri: "https://fcs.executivedashboard.innive.com/",
        redirectUri: " https://fdsdashboardui-wckqd7o3eq-uw.a.run.app/"
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);
